<ng-container [ngSwitch]="myOnboardingStage$ | async">
  <is-login *ngSwitchCase="'unauthenticated'"></is-login>
  <is-confirm-email *ngSwitchCase="'email-not-verified'"></is-confirm-email>
  <is-unauthorised *ngSwitchCase="'unauthorised'"></is-unauthorised>
  <p *ngSwitchCase="'onboarded'">Starting the engines...</p>
</ng-container>
